import React from 'react';
import {
 Field, reduxForm, formValueSelector, clearFields,
} from 'redux-form';
import { connect } from 'react-redux';

/**
 * Components
 */
import Textfield from 'components/textfield';
import Button from 'components/button';
import Checkbox from 'components/checkbox';
import Phone from 'src/components/phone';
import FormValidator from './landing-form-validator';

const selector = formValueSelector('landing-form');

const validateEmails = (values) => {
  const errors = {};
  if (values.cus_email_0 !== values.cus_email_confirm_0) {
    errors.cus_email_confirm_0 = 'Os e-mails não coincidem';
  }
  return errors;
};

const LandingForm = ({
  handleSubmit, submitting, dispatch, membroExterior, onSubmit: onSubmitForm,
}) => {
  const isExterior = membroExterior === 'S';

  const onSubmit = (values) => {
    // eslint-disable-next-line camelcase
    const { cus_email_confirm_0, ...filteredValues } = values;
    onSubmitForm(filteredValues);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <Field
        white
        type="name"
        name="cus_nome_razao_social_0"
        component={Textfield}
        label="Nome completo"
        placeholder="Informe seu nome"
        required
        maxLength={100}
      />
      <Field
        white
        type="email"
        autoComplete="off"
        name="cus_email_0"
        component={Textfield}
        label="E-mail"
        placeholder="Informe seu e-mail"
        required
      />
      <Field
        white
        type="email"
        autoComplete="off"
        name="cus_email_confirm_0"
        component={Textfield}
        label="Confirme seu E-mail"
        placeholder="Confirme seu e-mail"
        required
      />
      <Field
        white
        type="text"
        name="cus_data_nascimento_fundacao_0"
        component={Textfield}
        label="Data de Nascimento"
        placeholder="Informe sua data de nascimento"
        mask="99/99/9999"
      />
      <Field
        white
        type="text"
        name="cus_cpf_cnpj_0"
        component={Textfield}
        label="CPF"
        placeholder="Informe seu CPF"
        mask="999.999.999-99"
        disabled={isExterior}
      />
      <Field
        component={Checkbox}
        type="checkbox"
        name="membro_exterior"
        label="Não sou cidadão Brasileiro"
        normalize={(value) => (value ? 'S' : 'N')}
        white
        onChange={({ target }) => {
          if (target.checked) {
            dispatch(
              clearFields('landing-form', false, false, ['cus_cpf_cnpj_0']),
            );
          }
        }}
      />
      <Field
        white
        type="tel"
        name="cus_celular_0"
        component={Phone}
        label="Celular"
        placeholder="Informe seu celular"
        defaultCountry="BR"
      />
      <br />
      <div className="fifth-section-content-form-button">
        <Button type="submit" orange disabled={submitting}>
          {submitting ? 'Enviando...' : 'CONTINUAR AFILIAÇÃO'}
        </Button>
      </div>
    </form>
  );
};

const mapStateToProps = (state) => ({
  membroExterior: selector(state, 'membro_exterior'),
});

export default connect(
  mapStateToProps,
)(
  reduxForm({
    form: 'landing-form',
    validate: validateEmails,
    asyncValidate: FormValidator,
    destroyOnUnmount: false,
  })(LandingForm),
);
